import { render, staticRenderFns } from "./hot-supply.vue?vue&type=template&id=58bb0e6c&scoped=true&"
import script from "./hot-supply.vue?vue&type=script&lang=js&"
export * from "./hot-supply.vue?vue&type=script&lang=js&"
import style0 from "./hot-supply.vue?vue&type=style&index=0&id=58bb0e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb0e6c",
  null
  
)

export default component.exports